/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Optional slot capacity override. Applied only if the EventKind allows custom capacity.
 */
export type CreateSlotsRequestCapacity = number | null;
